module.exports = __webpack_public_path__ + "assets/img/ic-interchange.2836f5f1.svg";